export enum profileStepperDataTestIds {
  PROFILE_STEPPER_CONTAINER = "profile-stepper-container",
  PROFILE_STEPPER_MOBILE = "profile-stepper-mobile",
  PROFILE_STEPPER_DESKTOP = "profile-stepper-desktop",
}

export enum profileAvatarDataTestIds {
  PROFILE_AVATAR_LINK = "profile-avatar-link",
  PROFILE_AVATAR = "profile-avatar",
}

export enum profileButtonDataTestIds {
  PROFILE_BUTTON = "profile-button",
  PROFILE_BUTTON_AVATAR = "profile-button-avatar",
  PROFILE_MENU_PROFILE = "profile-menu-profile",
  PROFILE_MENU_SUPPORT = "profile-menu-support",
  PROFILE_MENU_RELEASE_HIJACK = "profile-menu-release-hijack",
  PROFILE_MENU_LOGOUT = "profile-menu-logout",
}

export enum profileFormTestIds {
  FIRST_NAME_INPUT = "profile-form-first-name-input",
  LAST_NAME_INPUT = "profile-form-last-name-input",
  PHONE_INPUT = "profile-form-phone-input",
  STATE_PREF_DROPDOWN = "profile-form-state-preferences",
  SMS_OPT_IN = "profile-form-sms-opt-in",
  SAVE_CONTINUE = "profile-form-save-continue",
}

export enum profileQualificationsTestIds {
  RESUME_UPLOAD = "profile-qualifications-resume-upload",
  RESUME_UPDATE = "profile-qualifications-resume-update",
  TEACHING_EXPERIENCE = "profile-qualifications-teaching-experience",
  WORK_ELIGIBILITY_YES = "profile-qualifications-work-eligibility-yes",
  WORK_ELIGIBILITY_NO = "profile-qualifications-work-eligibility-no",
  CERTIFICATIONS_YES = "profile-qualifications-certifications-yes",
  CERTIFICATIONS_NO = "profile-qualifications-certifications-no",
  CERTIFICATIONS_STATE = "profile-qualifications-cert-state",
  CERTIFICATIONS_SUBJECT = "profile-qualifications-cert-subject",
  CERTIFICATIONS_ADD = "profile-qualifications-cert-add",
  CERTIFICATIONS_DELETE = "profile-qualifications-cert-delete",
  CERTIFICATIONS_LICENSE = "profile-qualifications-cert-license",
  CERTIFICATIONS_NAME = "profile-qualifications-cert-name",
  CERTIFICATIONS_PROOF_INPUT = "profile-qualifications-cert-proof-image",
  CERTIFICATIONS_PROOF_UPDATE = "profile-qualifications-cert-proof-update",
  EMERGENCY_CREDENTIAL_YES = "profile-qualifications-emergency-credential-yes",
  EMERGENCY_CREDENTIAL_NO = "profile-qualifications-emergency-credential-no",
  EDUCATION_ADD = "profile-qualifications-education-add",
  EDUCATION_DELETE = "profile-qualifications-education-delete",
  EDUCATION_DEGREE = "profile-qualifications-education-degree",
  EDUCATION_SCHOOL = "profile-qualifications-education-school",
  EDUCATION_MAJOR = "profile-qualifications-education-major",
  BACK = "profile-qualifications-back",
  CONTINUE = "profile-qualifications-continue",
}

export enum profilePreferencesTestIds {
  LOCATION = "profile-preferences-location",
  DISTANCE = "profile-preferences-distance",
  SUBJECTS = "profile-preferences-subjects",
  GRADES = "profile-preferences-grades",
  HIDE_SCHOOLS = "profile-preferences-hide-schools",
  JOB_SEEKING_STATUS = "profile-preferences-job-seeking-status",
  JOB_SEEKING_STATUS_OPEN_TO_MATCHES = "profile-preferences-job-seeking-status-open-to-matches",
  JOB_SEEKING_STATUS_OPEN_TO_WORK = "profile-preferences-job-seeking-status-open-to-work",
  JOB_SEEKING_STATUS_CLOSED_TO_WORK = "profile-preferences-job-seeking-status-closed-to-work",
  RELOCATION_STATUS_CURRENTLY_LIVE_IN_AREA = "profile-preferences-relocation-status-currently-live-in-area",
  RELOCATION_STATUS_PLANNING_TO_RELOCATE = "profile-preferences-relocation-status-planning-to-relocate",
  RELOCATION_PREFERENCES = "profile-preferences-relocation-preferences",
  BACK = "profile-preferences-back",
  SAVE_CONTINUE = "profile-flow-preferences-form-save-and-continue-button",
}

export enum profileQuizPromptTestIds {
  BEGIN_QUIZ_BUTTON = "profile-quiz-begin-button",
  NOT_RIGHT_NOW_BUTTON = "profile-quiz-not-right-now-button",
}

export enum profileProgressTrackerHeaderTestIds {
  TRIGGER_BUTTON = "profile-progress-tracker-header-trigger-button",
  POPOVER_CONTENT = "profile-progress-tracker-header-popover-content",
}
